import { render, staticRenderFns } from "./Asta.vue?vue&type=template&id=7d734a62&scoped=true&"
import script from "./Asta.vue?vue&type=script&lang=js&"
export * from "./Asta.vue?vue&type=script&lang=js&"
import style0 from "./Asta.vue?vue&type=style&index=0&id=7d734a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d734a62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d734a62')) {
      api.createRecord('7d734a62', component.options)
    } else {
      api.reload('7d734a62', component.options)
    }
    module.hot.accept("./Asta.vue?vue&type=template&id=7d734a62&scoped=true&", function () {
      api.rerender('7d734a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Asta.vue"
export default component.exports